import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Title = styled.div`
  font-weight: 600;
  font-size: 18px;
`;

export const AccordionContent = styled.div`
  padding: 16px 24px;
`;

export const AccordionContentDate = styled.div`
  color: ${(props) => props.theme.color.dark.default};
  font-weight: 600;
  line-height: 16px;

  svg {
    vertical-align: bottom;
  }
`;

export const CardItemWrapper = styled.div`
  height: 300px;
  padding: 15px;
  width: 25%;
  ${mediaQuery('desktop')} {
    width: ${(1 / 3) * 100}%;
  }
  ${mediaQuery('medium')} {
    width: 50%;
  }

  ${mediaQuery('tablet')} {
    width: 100%;
  }
`;
export const LoadMoreContainer = styled.div`
  text-align: center;
`;
